/* Home page journal: when the blog has no articles yet, tapping a journal card opens the post in a reader pop-up on the same page. Vanilla JS. */
(function () {
  'use strict';
  function init(root) {
    if (root.__bnlJournal) return;
    root.__bnlJournal = true;
    var dlg = root.querySelector('[data-journal-reader]');
    if (!dlg) return;
    var posts = Array.prototype.slice.call(dlg.querySelectorAll('[data-journal-post]'));
    var opener = null;

    function show(n) {
      posts.forEach(function (p) { p.hidden = p.getAttribute('data-journal-post') !== String(n); });
      dlg.scrollTop = 0;
      var inner = dlg.querySelector('[data-journal-post]:not([hidden])');
      if (inner) inner.scrollTop = 0;
    }
    function open(n, from) {
      opener = from || opener;
      show(n);
      if (!dlg.open) {
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        document.documentElement.classList.add('jreader-lock');
      }
    }
    function close() {
      if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
    }
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('jreader-lock');
      if (opener && opener.focus) opener.focus();
    });
    root.addEventListener('click', function (e) {
      var o = e.target.closest ? e.target.closest('[data-journal-open]') : null;
      if (o && root.contains(o)) { e.preventDefault(); open(o.getAttribute('data-journal-open'), o); return; }
      if (e.target.closest && e.target.closest('[data-journal-close]')) { close(); return; }
      if (e.target === dlg) close(); /* tap on the dark backdrop */
    });
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('.journal'), function (s) { init(s.parentElement || s); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
